import { Link } from "react-router-dom";
import SectionTitle from "@/components/base/SectionTitle";
import { news } from "@/mocks/news";

const latest = news.slice(0, 5);

export default function NewsQuickList() {
  return (
    <section>
      <SectionTitle
        title="电影资讯快览"
        subtitle="最新5条电影资讯速读"
        extra={
          <Link
            to="/category/news"
            className="text-sm text-primary-700 hover:text-primary-800 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-s-line" />
          </Link>
        }
      />
      <div className="flex flex-col gap-3">
        {latest.map((item, idx) => (
          <Link
            key={item.id}
            to={`/detail/news/${item.id}`}
            className="group flex gap-4 bg-background-50 rounded-lg border border-background-200 hover:border-primary-300 p-4 transition-all cursor-pointer"
          >
            <div className="hidden sm:flex w-10 h-10 shrink-0 rounded-md bg-primary-50 text-primary-700 font-heading font-extrabold items-center justify-center">
              {String(idx + 1).padStart(2, "0")}
            </div>
            <div className="min-w-0 flex-1">
              <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950 leading-snug line-clamp-1 group-hover:text-primary-700 transition-colors">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 mt-1.5 line-clamp-1">
                {item.excerpt}
              </p>
            </div>
            <div className="hidden md:flex items-center gap-1 text-xs text-foreground-400 whitespace-nowrap self-center">
              <i className="ri-time-line" />
              {item.date}
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}